import request from "../util/request";
import local from "../util/local";
import queryString from "qs";
import _ from "lodash";
import locations from "@src/constants/locations.json";
import { message } from "antd";
import { DEFAULT_MODEL_SELECT_FIELD, IS_DEBUG } from "@src/constants/constants";

class Helper {
  safeStr = (str: string) => {
    // eslint-disable-next-line no-useless-escape
    str = str.replace(/\"/g, "");
    str = str.replace(/\//g, "");
    return str;
  };

  replaceAll = (str: string, search: string, replacement: string) => {
    if (!str) str = "";
    return str.replace(new RegExp(search, "g"), replacement);
  };

  reorder = (list: Array<any>, startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  getLocationName = (type: string, id: number) => {
    const arr = (locations as any)[type];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id === id) return arr[i].name;
    }
    return null;
  };

  getApiByName = (apis: any, name: string) => {
    for (let i = 0; i < apis.length; i++) {
      if (apis[i].name === name) return apis[i];
    }
    return null;
  };
  getTableChange = (resource: any) => {
    const tableChangeStr = sessionStorage.getItem(`${resource}_tableChange`);
    if (tableChangeStr) return JSON.parse(tableChangeStr);
    return JSON.parse("{}");
  };
  setTableChange = (resource: any, obj: any) => {
    sessionStorage.setItem(
      `${resource}_tableChange`,
      JSON.stringify({ ...obj })
    );
  };

  toDot = (money: number) => {
    if (IS_DEBUG) {
      console.log("@@the money", money);
    }
    if (money !== 0 && !money) return "0";
    return `${money}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  };

  showCustomModal = (opts: Record<string, any>) => {
    const { type, props } = opts;
    const store = (window as any)._store;
    return new Promise((resolve) => {
      store.dispatch({
        type: "modal/pushModal",
        data: {
          type,
          props,
          cb: (rs: any) => {
            resolve(rs);
          },
        },
      });
    });
  };

  setUserInfo = (info: Record<string, any>) => {
    const store = (window as any)._store;
    store.dispatch({
      type: "SET_USER_INFO",
      data: info,
    });
  };

  alert = (content: any, type?: "info" | "success" | "warning" | "error") => {
    switch (type) {
      case "success":
        message.success(content, 3);
        break;
      case "warning":
        message.warning(content, 3);
        break;
      case "error":
        message.error(content, 3);
        break;
      default:
        message.info(content, 3);
        break;
    }
    /* return new Promise((resolve) => {
      const store = (window as any)._store
      store.dispatch({
        type: 'modal/pushModal',
        data: {
          type: 'message',
          content,
          cb: (rs: any) => {
            resolve(rs)
          },
        },
      })
    }) */
  };

  confirm = (content: any) => {
    return new Promise((resolve) => {
      const store = (window as any)._store;
      store.dispatch({
        type: "modal/pushModal",
        data: {
          type: "confirm",
          content,
          cb: (rs: any) => {
            resolve(rs === 1);
          },
        },
      });
    });
  };

  private parseExportBase64Segment = (
    raw: string,
    fallbackMime: string
  ): { base64: string; mimeType: string } | null => {
    const trimmed = raw.trim();
    const dataUrlMatch = /^data:([^;]+);base64,(.+)$/i.exec(trimmed);
    if (dataUrlMatch) {
      return { mimeType: dataUrlMatch[1], base64: dataUrlMatch[2] };
    }
    if (!trimmed) {
      return null;
    }
    return { base64: trimmed, mimeType: fallbackMime };
  };

  private triggerBlobDownloadFromBase64 = (
    base64: string,
    mimeType: string,
    fileName: string
  ): boolean => {
    try {
      const sanitized = base64.replace(/\s/g, "");
      const binaryString = atob(sanitized);
      const byteLength = binaryString.length;
      const bytes = new Uint8Array(byteLength);
      for (let index = 0; index < byteLength; index += 1) {
        bytes[index] = binaryString.charCodeAt(index);
      }
      const blob = new Blob([bytes], { type: mimeType });
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = objectUrl;
      anchor.download = fileName;
      anchor.rel = "noopener";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(objectUrl);
      return true;
    } catch {
      return false;
    }
  };

  private triggerDataUrlDownload = (
    dataUrl: string,
    fileName: string
  ): boolean => {
    try {
      const anchor = document.createElement("a");
      anchor.href = dataUrl;
      anchor.download = fileName;
      anchor.rel = "noopener";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      return true;
    } catch {
      return false;
    }
  };

  private getFileExtensionFromMimeType = (contentType?: string): string => {
    const mimeType = (contentType || "").toLowerCase();
    if (mimeType.includes("spreadsheetml.sheet")) return "xlsx";
    if (mimeType.includes("application/vnd.ms-excel")) return "xls";
    if (mimeType.includes("text/csv")) return "csv";
    if (mimeType.includes("application/pdf")) return "pdf";
    if (mimeType.includes("application/json")) return "json";
    if (mimeType.includes("text/plain")) return "txt";
    if (mimeType.includes("application/zip")) return "zip";
    return "bin";
  };

  private buildFallbackFileName = (
    contentType?: string,
    defaultBaseName?: string
  ): string => {
    const normalizedBaseName = (defaultBaseName || "download")
      .trim()
      .replace(/[\\/:*?"<>|]+/g, "-");

    if (/\.[a-zA-Z0-9]{2,5}$/i.test(normalizedBaseName)) {
      return normalizedBaseName;
    }

    const extension = this.getFileExtensionFromMimeType(contentType);
    const finalExtension = extension === "bin" ? "xlsx" : extension;

    if (normalizedBaseName.toLowerCase().endsWith(`.${finalExtension}`)) {
      return normalizedBaseName;
    }

    return `${normalizedBaseName}.${finalExtension}`;
  };

  private getFileNameFromDisposition = (
    contentDisposition?: string,
    contentType?: string,
    defaultBaseName?: string
  ): string => {
    const fallbackFileName = this.buildFallbackFileName(
      contentType,
      defaultBaseName
    );
    if (!contentDisposition) {
      return fallbackFileName;
    }
    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
    if (utf8Match && utf8Match[1]) {
      const decoded = decodeURIComponent(utf8Match[1]).replace(/["']/g, "");
      return /\.[a-zA-Z0-9]{2,5}$/i.test(decoded)
        ? decoded
        : this.buildFallbackFileName(contentType, decoded);
    }
    const asciiMatch = /filename="?([^";]+)"?/i.exec(contentDisposition);
    if (asciiMatch && asciiMatch[1]) {
      const name = asciiMatch[1].trim();
      return /\.[a-zA-Z0-9]{2,5}$/i.test(name)
        ? name
        : this.buildFallbackFileName(contentType, name);
    }
    return fallbackFileName;
  };

  tryDownloadExportResponse = (
    response: any,
    defaultBaseName?: string
  ): boolean => {
    if (!response || !response.data) {
      return false;
    }
    const responseData = response.data;
    const isBlob = typeof Blob !== "undefined" && responseData instanceof Blob;
    const isArrayBuffer =
      typeof ArrayBuffer !== "undefined" && responseData instanceof ArrayBuffer;

    if (!isBlob && !isArrayBuffer) {
      return false;
    }

    try {
      const headers = response.headers || {};
      const contentDisposition =
        headers["content-disposition"] || headers["Content-Disposition"];
      const contentType =
        headers["content-type"] ||
        headers["Content-Type"] ||
        "application/octet-stream";
      const fileName = this.getFileNameFromDisposition(
        contentDisposition,
        contentType,
        defaultBaseName
      );
      const blob = isBlob
        ? responseData
        : new Blob([responseData], { type: contentType });

      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = objectUrl;
      anchor.download = fileName;
      anchor.rel = "noopener";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(objectUrl);
      return true;
    } catch {
      return false;
    }
  };

  /**
   * Nút `mode: export`: đọc file từ body JSON (base64 hoặc data URL).
   * Hỗ trợ phẳng hoặc lồng trong `data` / `result` / `payload`.
   */
  tryDownloadExportPayload = (responseBody: any): boolean => {
    if (!responseBody || typeof responseBody !== "object") {
      return false;
    }
    if (
      typeof responseBody.errorCode === "number" &&
      responseBody.errorCode !== 0
    ) {
      return false;
    }

    const pickString = (
      obj: Record<string, any>,
      keys: string[]
    ): string | undefined => {
      for (const key of keys) {
        const value = obj[key];
        if (typeof value === "string" && value.length > 0) {
          return value;
        }
      }
      return undefined;
    };

    const fileNameKeys = [
      "fileName",
      "filename",
      "name",
      "file_name",
      "downloadFileName",
    ];
    const base64Keys = ["base64", "content", "file", "fileContent", "buffer"];

    const nestedObjects: Record<string, any>[] = [];
    const pushIfPlainObject = (value: unknown) => {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        nestedObjects.push(value as Record<string, any>);
      }
    };

    pushIfPlainObject(responseBody);
    pushIfPlainObject(responseBody.data);
    pushIfPlainObject(responseBody.result);
    pushIfPlainObject(responseBody.payload);

    for (const obj of nestedObjects) {
      const fileName = pickString(obj, fileNameKeys) || "download.bin";

      const dataUrlValue =
        pickString(obj, ["dataUrl"]) ||
        (typeof obj.url === "string" && obj.url.startsWith("data:")
          ? obj.url
          : undefined);
      if (dataUrlValue && dataUrlValue.startsWith("data:")) {
        return this.triggerDataUrlDownload(dataUrlValue, fileName);
      }

      let base64Raw = pickString(obj, base64Keys);
      const dataField = obj.data;
      if (
        !base64Raw &&
        typeof dataField === "string" &&
        dataField.length > 0 &&
        !dataField.trim().startsWith("{")
      ) {
        base64Raw = dataField;
      }
      if (!base64Raw) {
        continue;
      }

      const defaultMime =
        pickString(obj, ["mimeType", "contentType", "mime"]) ||
        "application/octet-stream";
      const parsed = this.parseExportBase64Segment(base64Raw, defaultMime);
      if (!parsed) {
        continue;
      }
      if (
        this.triggerBlobDownloadFromBase64(
          parsed.base64,
          parsed.mimeType,
          fileName
        )
      ) {
        return true;
      }
    }

    return false;
  };

  callPageApi = (page: any, name: string, data: any, requestOptions?: any) => {
    const api: any = this.getApiByName(page.apis, name);
    const optionPayload = Array.isArray(api?.options)
      ? api.options.reduce((acc: Record<string, any>, option: any) => {
          if (option?.key) {
            acc[option.key] = option.value;
          }
          return acc;
        }, {})
      : {};
    const requestPayload = Object.assign({}, optionPayload, data || {});
    const isExportApi =
      optionPayload.isExport === true ||
      optionPayload.isExport === "true" ||
      optionPayload.isExport === 1 ||
      optionPayload.isExport === "1";
    let input = _.clone(requestPayload);
    let url: string = api.url;
    // if (new RegExp('^(/api/)[ a-z0-9_@./#&+-]+$').test(url)) {
    //   url = url.substr(4, url.length - 1)
    // }
    if (url.startsWith("/api/")) {
      url = url.substr(4, url.length - 1);
    }
    switch (api.method) {
      case "GET":
        for (const i in requestPayload) {
          if (requestPayload[i] === undefined) delete requestPayload[i];
        }
        input = Object.assign(
          {},
          {
            page: page.id,
            api: api.name,
          },
          requestPayload
        );
        url += `?${queryString.stringify(input)}`;
        break;
      case "PATCH":
      case "DELETE":
        if (api.type === "update") {
          // Dedicated Many APIs (like deleteMany) don't need a path ID.
          // Resource-based updates/deletes need the ID in the path.
          if (api.name !== "deleteMany" && requestPayload.id) {
            url += `/${requestPayload.id}`;
          }
          delete input.id;
        }
        url += `?${queryString.stringify({ page: page.id, api: api.name })}`;
        break;
      default:
        url += `?${queryString.stringify({ page: page.id, api: api.name })}`;
        break;
    }
    return request({
      url: `${url}`,
      options: {
        method: api.method,
        data: requestPayload,
        ...(isExportApi ? { responseType: "blob" } : {}),
        ...(requestOptions || {}),
      },
    });
  };

  callPublicApi = (name: string, apiUrl: string, method: string, data: any) => {
    const api: any = { name, url: apiUrl, method };
    let input = _.clone(data);
    let url: string = api.url;
    if (url.startsWith("/api/")) {
      url = url.substr(4, url.length - 1);
    }
    switch (api.method) {
      case "GET":
        for (const i in data) {
          if (data[i] === undefined) delete data[i];
        }
        input = Object.assign(
          {},
          {
            api: api.name,
          },
          data
        );
        url += `?${queryString.stringify(input)}`;
        break;
      case "PATCH":
      case "DELETE":
        if (api.type === "update") {
          url += `/${data.id}?${queryString.stringify({
            api: api.name,
          })}`;
          delete input.id;
        }
        break;
      default:
        url += `?${queryString.stringify({ api: api.name })}`;
        break;
    }
    return request({
      url: `${url}`,
      options: {
        method: api.method,
        data,
      },
    });
  };

  getReportUrl = (page: any, name: string, data: any) => {
    const api: any = this.getApiByName(page.apis, name);
    let input = _.clone(data),
      url = api.url;
    switch (api.method) {
      case "GET":
        for (const i in data) {
          if (data[i] === undefined) delete data[i];
        }
        input = Object.assign(
          {},
          {
            page: page.id,
            api: api.name,
            accesstoken: local.get("token") || "customer",
          },
          data
        );
        url += `?${queryString.stringify(input)}`;
        break;
      default:
        break;
    }
    if (IS_DEBUG) {
      console.log("report url", url);
    }
    return url;
  };

  getApiUrl = (page: any, name: string) => {
    let api = null;
    for (let i = 0; i < page.apis.length; i++) {
      if (page.apis[i].name === name) {
        api = page.apis[i];
        break;
      }
    }
    switch (api.action) {
      default:
        return `/${api.controller}/${api.action}?page=${page.id}&api=${name}`;
    }
  };

  getPage = async (id: number) => {
    id = Number(id);
    const meta = local.get("meta");
    const pages = meta.pages;
    for (let i = 0; i < (pages || []).length; i++) {
      if (pages[i].id === id) {
        if (!Array.isArray(pages[i].buttons)) pages[i].buttons = [];
        return pages[i];
      }
    }
  };

  getValue = (obj: Record<string, any> | string | number) => {
    if (IS_DEBUG) {
      console.log(
        `🚀 ~ file: controlHelper.tsx ~ line 233 ~ Helper ~ obj`,
        obj
      );
    }
    if (typeof obj === "object") {
      return Object.keys(obj)
        .map((key) => obj[key])
        .join(",");
    }
    return obj;
  };

  transformModelSelectField = (_fields: string) => {
    const _fieldName: any = {};
    const _fieldNameArr = (_fields || DEFAULT_MODEL_SELECT_FIELD).split(",");
    _fieldNameArr.forEach((n: string) => {
      const arr = n.split("$$");
      _fieldName[arr[0]] = arr[1] || arr[0];
    });
    return _fieldName;
  };
}

export const helper = new Helper();
